module.exports = __webpack_public_path__ + "static/media/arrow-down.bc83f5e1.svg";